import { ActionModify, FaqState } from '@/typings/reducer';

export enum FAQ_TYPE {
    // 设置faq基本信息
    SET_FAQ_SESSION = 'SET_FAQ_SESSION',
    // 改变faq行为状态
    CHANGE_FAQ_STATUS = 'CHANGE_FAQ_STATUS',
    // 插入faq消息
    SET_FAQ_MESSAGE = 'SET_FAQ_MESSAGE',
    // 更新消息的 Dify 上下文内容
    UPDATE_FAQ_SERVER_CONTENT = 'UPDATE_FAQ_SERVER_CONTENT',
    // faq解决/未解决
    // SET_FAQ_RESOLVE = 'SET_FAQ_RESOLVE',
    // 点击转换按钮
    SET_STAGE_CLICK = 'SET_STAGE_CLICK',
    // 重制faq状态
    RELOAD_FAQ = 'RELOAD_FAQ',
    // 重制数据
    SET_DEFAULT_STATE = 'SET_DEFAULT_STATE',
    // 移除faq loading消息
    REMOVE_FAQ_LOADING = 'REMOVE_FAQ_LOADING',
    // 更新dify无答案次数
    UPDATE_NO_ANSWER_COUNT = 'UPDATE_NO_ANSWER_COUNT'
}
export interface FAQChangeFaqStatusAction {
    type: FAQ_TYPE.CHANGE_FAQ_STATUS;
    payload: boolean;
}
export interface FAQSetStageClickAction {
    type: FAQ_TYPE.SET_STAGE_CLICK;
    payload: boolean;
}
export interface FAQSetFaqSessionAction {
    type: FAQ_TYPE.SET_FAQ_SESSION;
    payload: FaqState;
}
export interface FAQReloadFaqAction {
    type: FAQ_TYPE.RELOAD_FAQ;
    payload?: never;
}
export interface FAQSetDefaultStateAction {
    type: FAQ_TYPE.SET_DEFAULT_STATE;
    payload?: never;
}
export interface FAQUpdateNoAnswerCountAction {
    type: FAQ_TYPE.UPDATE_NO_ANSWER_COUNT;
    payload: number;
}

export type FAQModifyAction =
    | ActionModify<FAQChangeFaqStatusAction, FaqState>
    | ActionModify<FAQSetStageClickAction, FaqState>
    | ActionModify<FAQSetFaqSessionAction, FaqState>
    | ActionModify<FAQReloadFaqAction, FaqState>
    | ActionModify<FAQSetDefaultStateAction, FaqState>
    | ActionModify<FAQUpdateNoAnswerCountAction, FaqState>;
export type FAQModifyType = FAQ_TYPE;
